import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './modules/tagsView'

Vue.use(Vuex)

export default new Vuex.Store({
  // 👇 只保留一个 modules，把 tagsView 加进去
  modules: {
    tagsView
  },
  
  state: {
    permission: [],
    order_company: '',
    auth_type: 'order',
    roles: []
  },
  getters: {
    roles: (state) => state.roles,
    isOrderCompany () {
      if (sessionStorage.getItem('order_company')) {
        return false
      } else {
        return true
      }
    }
  },
  mutations: {
    SET_ROLES: (state, roles) => {
      state.roles = roles
      sessionStorage.setItem('roles', JSON.stringify(roles))
    },
    SET_PERMISSION (state, permission) {
      state.permission = permission
    },
    SET_ORDER_COMPANY (state, value) {
      state.order_company = value
      sessionStorage.setItem('order_company', value)
    },
    CLEAR_INFO (state) {
      state.order_company = ''
      state.permission = []
    },
    updataState (state) {
      state.roles = JSON.parse(sessionStorage.getItem('roles'))
    }
  },
  actions: {
    SET_PERMISSION (context, permission) {
      context.commit('SET_PERMISSION', permission)
    },
    SET_ORDER ({ commit }, value) {
      commit('SET_ORDER_COMPANY', value)
    },
    CLEAR ({ commit }) {
      commit('CLEAR_INFO')
    }
  }

})